.map {
	width: 100%;
	height: 200px;
	border-radius: var(--radius-md);
	overflow: hidden;
	background: var(--surface-input);
}
